import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { Notyf } from 'notyf';
import useAuthenticatedApi from '../../../hooks/useAuthenticatedApi';

const useDeleteStudy = () => {
  const notyf = new Notyf();
  const history = useHistory();
  const { deleteStudy } = useAuthenticatedApi();

  const { mutate, isLoading } = useMutation(
    async ({ slug }: { slug: string }) => await deleteStudy({ slug }),
    {
      onSuccess: () => {
        notyf.success({
          message: 'Study deleted successfully',
          background: 'rgb(67 56 202)',
        });
        history.push('/studies');
      },
      onError: (error: any) => {
        notyf.error({
          message: error.message || 'Failed to delete study',
          dismissible: true,
        });
      },
    }
  );

  return {
    deleteStudy: mutate,
    isDeleting: isLoading,
  };
};

export default useDeleteStudy;
